/*
  assets/hub-mobile-filter-drawer.js
  ---------------------------------------------------------------------------
  Abre/cierra el drawer de filtros de Nivel 2 en móvil (sections/pages-hub
  .liquid) — a pedido, para que se vea y se comporte igual que el drawer
  nativo de la collection page (Nivel 3, #mobile-collection-filters en
  sections/main-collection.liquid).

  Por qué un script chico y aparte, no el CollectionFilterDrawer nativo de
  theme.js: ese depende de que la sección declare
  data-section-type="collection" (así se instancia CollectionSection, que
  a su vez crea el CollectionFilterDrawer) — esta plantilla nunca declaró
  ese tipo de sección, así que engancharse ahí hubiera significado activar
  TODO lo que trae CollectionSection (AJAX de filtros nativo, toggle de
  layout, conteo de productos, etc.), pensado para main-collection.liquid,
  no para el motor propio de Nivel 2 (hub-storefront-filters.js). Mismas 4
  operaciones que CollectionFilterDrawer (abrir, cerrar, detectar click
  afuera, recalcular alto en resize), reescritas acá de forma aislada.

  Reusa las mismas clases .drawer/.collection-drawer* de theme.css sin
  tocarlas — el CSS que neutraliza el comportamiento de drawer en
  escritorio vive en el <style> de pages-hub.liquid, no acá.
*/
(function () {
  'use strict';

  var drawer = document.getElementById('mobile-collection-filters');
  var toggle = document.querySelector('[aria-controls="mobile-collection-filters"][data-action="open-drawer"]');
  if (!drawer || !toggle) return;

  var isOpen = false;

  function computeDrawerHeight() {
    var inner = drawer.querySelector('.collection-drawer');
    if (inner) inner.style.maxHeight = window.innerHeight + 'px';
  }

  function open(event) {
    if (event) event.stopPropagation();
    computeDrawerHeight();
    isOpen = true;
    toggle.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-locked');
  }

  function close(event) {
    if (event) event.stopPropagation();
    isOpen = false;
    toggle.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('is-locked');
  }

  toggle.addEventListener('click', open);

  drawer.querySelectorAll('[data-action="close-drawer"]').forEach(function (btn) {
    btn.addEventListener('click', close);
  });

  document.addEventListener('click', function (event) {
    if (isOpen && !event.target.closest('.collection-drawer__inner')) {
      close();
    }
  });

  window.addEventListener('resize', function () {
    if (isOpen) computeDrawerHeight();
  });
})();
